import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { DefaultDeliveryInformation } from '@app/registrations/shared/models/registration';
import { VehicleConfigurationV2Json } from '@api-client/ord/lib/ord-v2-api';

@Injectable()
export class AdministrationService {
  private readonly http = inject(HttpClient);

  public updateDefaultDeliveryInformation(deliveryInformation: DefaultDeliveryInformation['leasingCompanyDeliveryAddressesJson']): Observable<string> {
    return this.http.post<string>(`${environment.apiUrl}/leasing-company/default-delivery-information/address`, deliveryInformation);
  }

  public orderNotificationResource(): Observable<VehicleConfigurationV2Json.OrderNotificationVersionEnum[]> {
    return this.http.get<VehicleConfigurationV2Json.OrderNotificationVersionEnum[]>(
      `${environment.apiUrl}/order-notification/versions`
    );
  }
}
